<template>
    <v-footer color="grey lighten-5" app>
      <v-card-text class="py-2 text-center">
        {{ new Date().getFullYear() }} — Made with ♥ by <strong>Sp0m ™</strong>
      </v-card-text>
    </v-footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>
